<template>
  <!--业务公司-->
  <div>
    <div class="goods-head">
      <div class="slider-list">
        <div class="item selected">业务公司</div>
      </div>
      <!-- 查询表单  -->
      <div class="goods-head-form">
        <div class="fileds">
          <el-form ref="ruleForm" :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="公司名称">
              <!-- v-input-filter -->
              <el-input v-model.trim="formInline.companyName" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="formInline.customerName" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="客户类型">
              <el-select v-model="formInline.customerType" placeholder="请选择">
                <el-option label="svip" value="1" />
                <el-option label="vip" value="2" />
                <el-option label="普通客户" value="3" />
                <el-option label="老客户" value="4" />
                <el-option label="合作伙伴" value="5" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="buttons">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="searchCriteria(formInline)"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetForm('ruleForm')"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>
    <!--表格操作-->
    <section class="operations">
      <template>
        <el-button
          size="small"
          class="form-item-btn"
          type="primary"
          style="background-color: #BE2316;border-color: #F56C6C;"
          @click="addPopClick"
        >
          <i class="el-icon-plus" />新增
        </el-button>
        <el-button
          size="small"
          class="form-item-btn"
          type="primary"
          style="background-color: #BE2316;border-color: #F56C6C;"
          @click="batchDel"
        >
          <i class="el-icon-delete-solid" />批量删除
        </el-button>
      </template>
    </section>
    <!--表格-->
    <section class="main">
      <!--表格头部-->
      <article class="main-header">
        <ul>
          <li>
            <el-checkbox v-model="allSelection" @change="selection()" />
          </li>
          <li>公司名称</li>
          <li>公司地址</li>
          <li>客户类型</li>
          <li>是否业务客户</li>
          <li>客户名称</li>
          <li>联系人电话</li>
          <li>操作</li>
        </ul>
      </article>
      <!--表格内容-->
      <article class="main-body">
        <template v-if="detailsData.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(item,itemIndex) in detailsData">
          <div :key="itemIndex" class="body-item">
            <ul>
              <li>
                <el-checkbox v-model="item.selection" @change="change()" />
              </li>
              <li>{{ item.companyName }}</li>
              <li>{{ item.companyAddress }}</li>
              <li>
                <span v-if="item.customerType==1">svip</span>
                <span v-if="item.customerType==2">vip</span>
                <span v-if="item.customerType==3">普通客户</span>
                <span v-if="item.customerType==4">老客户</span>
                <span v-if="item.customerType==5">合作伙伴</span>
              </li>
              <li>
                <span v-if="item.isBusiness==1">否</span>
                <span v-if="item.isBusiness==2">是</span>
              </li>
              <li>{{ item.customerName }}</li>
              <li>{{ item.customerPhone }}</li>
              <li>
                <el-button type="text" @click="popEdit(item)">编辑</el-button>
                <el-divider direction="vertical" />
                <el-button type="text" @click="tableDelete(item.id)">删除</el-button>
                <!--<el-divider direction="vertical" />-->
                <!--<el-button type="text" @click="seeContactsClick(item)">查看联系人</el-button>-->
                <el-button plain size="small" @click="detailsClick(itemIndex)">
                  详情
                  <i :class="{'expand': detailsIndex == itemIndex}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <businessDetails v-if="detailsIndex == itemIndex" class="businessIf" :details="item" />
          </div>
        </template>
      </article>
      <!--分页-->
      <article class="main-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </article>
    </section>
    <!--新增编辑弹窗-->
    <addEditDialog
      v-if="dialogShow"
      :dialog-show="dialogShow"
      :pop-data="addPopData"
      :status="dialogStatus"
      :title="dialogTitle"
      @EchoClick="getSetList"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/personal/customer/business-enterprise/index.js' // 请求接口
import inputFilter from '@/directives/validation/index.js'
import businessDetails from '../components/business-details'
import { Page } from '@/utils/commonDataModel'
import addEditDialog from './components/addEditDialog'
export default {
  components: {
    businessDetails,
    addEditDialog
  },
  directives: {
    inputFilter
  },
  data() {
    return {
      // 新增业务弹窗状态
      dialogShow: false,
      // 弹窗状态
      dialogStatus: 'create',
      // 弹窗标题
      dialogTitle: '业务公司-新增',
      // 详情状态
      detailsIndex: -1,
      // 搜索条件表单
      formInline: {
        companyName: '',
        customerName: '',
        customerType: ''
      },
      // 全选状态
      allSelection: false,
      detailsData: [],
      // 新增业务数据
      addPopData: {
        companyName: '', // 公司名称
        companyAddress: '', // 公司地址
        relationName: '', // 联系人
        relationPhone: '', // 联系电话
        fixTelphone: '', // 固定电话
        customerType: '', // 客户类型
        isBusiness: '', // 是否业务用户
        customerMaturity: '', // 客户成熟度
        createDate: '', // 建立客户时间
        followDate: '', // 跟进时间
        remarks: '' // 备注
      },
      // 查看联系人数据
      seeContactsData: {},
      // 表格分页
      pagination: new Page(),
      // 保存和编辑 备注内容、字数
      titleMaxLength: 255
    }
  },
  created() {
    // 获取客户列表
    this.getSetList()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.searchCriteria(this.formInline)
      }
    }
  },
  methods: {
    // 关闭新增修改弹窗
    closeDialog() {
      this.dialogShow = false
      // 清空输入框
      this.addPopData = {
        companyName: '',
        companyAddress: '',
        relationName: '',
        relationPhone: '',
        fixTelphone: '',
        customerType: '',
        isBusiness: '',
        customerMaturity: '',
        createDate: '',
        followDate: '',
        remarks: '',
        id: ''
      }
    },
    // 获取客户列表
    getSetList() {
      get.getCustomerList().then(res => {
        this.pagination.total = res.result.total
        this.pagination.pageNo = res.result.pageNo
        this.pagination.pageSize = res.result.pageSize
        this.detailsData = res.result.rows
      }).catch(error => {
        return error
      })
    },
    // 条件查询按钮
    searchCriteria(data) {
      console.log(data)
      for (const i in data) {
        data[i] = data[i].replace(/\s+/g, '')
      }
      get.getCustomerList(data).then(res => {
        this.pagination.total = res.result.total
        this.pagination.pageNo = res.result.pageNo
        this.pagination.pageSize = res.result.pageSize
        this.detailsData = res.result.rows
      }).catch(error => {
        console.log(error)
      })
    },
    // 详情按钮
    detailsClick(index) {
      if (this.detailsIndex == index) {
        this.detailsIndex = -1
      } else {
        this.detailsIndex = index
      }
    },
    // 全选
    selection() {
      this.detailsData.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    // 子项多选
    change() {
      this.allSelection = this.detailsData.every(i => i.selection)
    },
    // 公司编辑按钮
    popEdit(data) {
      this.addPopData = data
      this.dialogTitle = '业务公司-编辑'
      this.dialogStatus = 'edit'
      this.dialogShow = true
    },
    // 新增公司
    addPopClick(formName) {
      // 根据id查询出对应列表
      this.dialogStatus = 'create'
      this.dialogTitle = '业务公司-新增'
      this.dialogShow = true
    },
    // 表格删除按钮
    tableDelete(id) {
      this.$confirm('此操作将删除选中数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        get.deleteStrip({
          id: id
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          // 获取客户列表
          get.getCustomerList().then(res => {
            this.pagination.total = res.result.total
            this.pagination.pageNo = res.result.pageNo
            this.pagination.pageSize = res.result.pageSize
            const odata = res.result.rows
            this.detailsData = odata.map(ele => {
              ele.selection = false
              return ele
            })
          }).catch(error => {
            console.log(error)
          })
        }).catch(error => {
          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 重置表单
    resetForm(formName) {
      // 官方文档的方法失效
      // this.$refs[formName].resetFields()
      this.formInline.companyName = ''
      this.formInline.customerName = ''
      this.formInline.customerType = ''
      this.getSetList()
    },
    // 批量删除
    batchDel() {
      // 如果为选中任何id,则提示用户选择要删除的数据
      const ids = this.detailsData.filter(item => item.selection).map(item => item.id)
      if (ids == '' || ids.length < 0) {
        this.$message({
          message: '请选择删除的数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('此操作将删除选中数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.detailsData.filter(item => item.selection).map(item => item.id)
        const idString = ids.join(',')
        if (ids.length > 0) {
          get.deleteForm({
            id: idString
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            // 获取客户列表
            get.getCustomerList().then(res => {
              this.pagination.total = res.result.total
              this.pagination.pageNo = res.result.pageNo
              this.pagination.pageSize = res.result.pageSize
              const odata = res.result.rows
              this.detailsData = odata.map(ele => {
                ele.selection = false
                return ele
              })
            }).catch(error => {
              console.log(error)
            })
            // 取消全选
            this.allSelection = false
          }).catch(error => {
            console.log(error)
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请选择删除的数据!'
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 分页-第几页
    changeCurrent(current) {
      this.pagination.pageNo = current
      get.getCustomerList(this.pagination).then(res => {
        this.pagination.total = res.result.total
        this.pagination.pageNo = res.result.pageNo
        this.pagination.pageSize = res.result.pageSize
        this.detailsData = res.result.rows
      }).catch(error => {
        console.log(error)
      })
    },
    // 分页-   每页多少条
    changeSize(size) {
      this.pagination.pageSize = size
      get.getCustomerList(this.pagination).then(res => {
        this.pagination.total = res.result.total
        this.pagination.pageNo = res.result.pageNo
        this.pagination.pageSize = res.result.pageSize
        this.detailsData = res.result.rows
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped lang='scss'>
 @import "./index.scss";
</style>
